<template>
    <div>
        <a-modal v-model:visible="value" :footer="null" :width="378" :zIndex="1100">
            <img src="~@/assets/images/deal-manage/tips.png" class="tip_image" />
            <div class="html_notice">温馨提示：包裹重量已超20KG，若继续发货，默认选择物流发货；若仍需快递发货，请拆包重新下订单！</div>
            <div class="footer_notice">
                <div class="button_notice" @click="ok">知道了</div>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'NoticeWeight',
    props: ['value'],
    methods: {
        ok(){
            this.$emit('input',false);
        }
    }
}
</script>

<style scoped>
.img_close{
    position: absolute;
    top: -40px;
    right: -40px;
    cursor: pointer;
    font-size: 32px;
    color: #fff;
}
.img_close:hover{
    color: #dedede;
}
.img_content{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10000;
}
.img_box{
    margin: 150px auto 0;
    position: relative;
}
.tip_image{
    width:100%;
}
.html_notice{
    text-align:center;
    padding:20px 0;
}
.html_notice p{
    line-height:20px;
}
.button_notice{
    background:url('~@/assets/images/deal-manage/button.png') no-repeat center center;
    width:110px;
    height:40px;
    background-size:100%;
    cursor: pointer;
    color:#fff;
    line-height:40px;
    font-size:16px;
    margin:0 auto;
}
.button_notice:hover{
    opacity: 0.8;
}
.footer_notice{
    width:100%;
    text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/NoticeWeight.vue